<template>

  <div class="ui grid animated fadeIn">

    <div class="sixteen wide column">

      <div class="ui segment" style="min-height: 150px; padding: 20px !important;">

        <div v-if="quotation.documents.length == 0" class="grey text">
          <i class="info circle icon"></i> Nenhum documento gerado
        </div>

        <table v-else class="ui very basic selectable celled table">
          <thead class="desktop-only">
            <tr>
              <th>Número</th>
              <th>Tipo</th>
              <th>Data</th>
              <th>Hora</th>
              <th>Observações</th>
            </tr>
          </thead>            
          <tbody>
            <tr v-for="document in quotation.documents" class="clickable" @click="onShow(document)">                   
              <td><strong class="mobile-only">Número: </strong>
                <i v-if="document.isDeleted" class="times circle red icon"></i>
                <i v-else class="check circle green icon"></i>
                {{ document.type == '1' ? document.id : document.id + '-' + document.series }}
              </td>
              <td><strong class="mobile-only">Tipo: </strong>{{ document.type == '1' ? 'Pedido de Vendas' : 'Nota Fiscal' }}</td>
              <td><strong class="mobile-only">Data: </strong>{{ $formatDate(document.date) }}</td>
              <td><strong class="mobile-only">Hora: </strong>{{ document.time }}</td>
              <td><strong class="mobile-only">Observações: </strong>{{ document.comments }}</td>
            </tr>                
          </tbody>
        </table>

      </div>

    </div>

    <sales-order-dialog ref="orderDialog" :branchId="selectedOrder.branchId" :orderId="selectedOrder.id" />
    <invoice-dialog ref="invoiceDialog" :branchId="selectedInvoice.branchId" :number="selectedInvoice.id" 
      :series="selectedInvoice.series" />

  </div>

</template>

<script>

  import { SalesOrderDialog, InvoiceDialog } from "@/components"
  import Message from "@/utils/message"

  export default {

    data() {
      return {
        selectedOrder: {},
        selectedInvoice: {},
      }
    },

    props: ["quotation"],   
    
    components: {
      SalesOrderDialog,
      InvoiceDialog,
    },

    methods: {

      onShow(document) {

        if (document.isDeleted) {
          Message.info("Esse documento foi excluído ou cancelado")
          return
        }        

        if (document.type == "1") {
          this.selectedOrder = document
          this.$refs.orderDialog.show()
        } else {
          this.selectedInvoice = document
          this.$refs.invoiceDialog.show()
        }
      },
    },
  }

</script>

